// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.protected-route-container[data-v-0d35f7bf] {\n  display: contents;\n}\n", ""]);
// Exports
module.exports = exports;
